/* ================================================
   DMY Studios — custom-script.js
   Hero Logo Overlay (Phoebe Philo style)

   SETTINGS (edit these to tune):
     HERO_IMAGE_HEIGHT  — height of logo in hero state (px)
     SCROLL_THRESHOLD   — how far user scrolls before fade starts
     SCROLL_COMPLETE    — how far user scrolls before fade is done

   Both mobile and desktop use fade-only (no translate/scale).
   The overlay uses the transparent (white) logo version.
   ================================================ */

(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) return;

  // document.addEventListener('DOMContentLoaded', initHeroLogo);

  function initHeroLogo() {
    const isHomepage = document.body.classList.contains('template-index');
    if (!isHomepage) return;

    const header = document.getElementById('shopify-section-header');
    if (!header) return;

    const headerLogo = header.querySelector('.logo');
    if (!headerLogo) return;

    /* ── Always use the transparent (white) logo ── */
    const logoImageEl = headerLogo.querySelector('.logo__image-item--transparent') ||
                        headerLogo.querySelector('.logo__image-item') ||
                        headerLogo.querySelector('img');
    const logoTextEl  = headerLogo.querySelector('.logo__title');
    const logoLink    = headerLogo.querySelector('a');
    const logoHref    = logoLink ? logoLink.href : '/';

    /* ── Build overlay ── */
    const overlay = document.createElement('div');
    overlay.id = 'dmy-hero-logo';
    overlay.setAttribute('aria-hidden', 'true');

    const overlayLink = document.createElement('a');
    overlayLink.href = logoHref;
    overlayLink.setAttribute('tabindex', '-1');

    if (logoImageEl) {
      overlayLink.className = 'dmy-hero-logo__image';
      const img = logoImageEl.cloneNode(true);
      img.removeAttribute('width');
      img.removeAttribute('height');
      img.removeAttribute('sizes');
      img.style.cssText = 'width:auto;height:auto;max-height:none;';
      overlayLink.appendChild(img);
    } else if (logoTextEl) {
      overlayLink.className = 'dmy-hero-logo__text';
      overlayLink.textContent = logoTextEl.textContent.trim();
      const computed = getComputedStyle(headerLogo);
      overlayLink.style.fontFamily = computed.getPropertyValue('--logo-font-family') || computed.fontFamily;
      overlayLink.style.fontWeight = computed.getPropertyValue('--logo-font-weight') || computed.fontWeight;
      overlayLink.style.fontStyle  = computed.getPropertyValue('--logo-font-style')  || computed.fontStyle;
    } else {
      overlayLink.className = 'dmy-hero-logo__text';
      overlayLink.textContent = document.title.split('–')[0].trim() || 'DMY Studios';
    }

    overlay.appendChild(overlayLink);

    /* Append INSIDE the appropriate header so the overlay shares that
       header's stacking context — mega menu dropdown is also a header
       child so it always paints on top naturally.
       Desktop header is hidden on mobile (max 920px) so we use the
       mobile header element there instead. */
    const mobileHeader = document.getElementById('shopify-section-mobile-header');
    const isMobileView = window.innerWidth <= 920;
    const targetHeader = (isMobileView && mobileHeader) ? mobileHeader : header;
    targetHeader.appendChild(overlay);

    document.body.classList.add('dmy-homepage-hero');

    /* ── Settings ── */
    const HERO_IMAGE_HEIGHT     = 160; /* px — hero logo height */
    const HERO_TEXT_SIZE        = 52;  /* px — text logo desktop */
    const HERO_TEXT_SIZE_MOBILE = 32;  /* px — text logo mobile */

    /* Apply full hero state */
    function applyHeroState() {
      if (logoImageEl) {
        const img = overlayLink.querySelector('img');
        if (img) {
          img.style.height = HERO_IMAGE_HEIGHT + 'px';
          img.style.width  = 'auto';
        }
      } else {
        overlayLink.style.fontSize = (window.innerWidth < 769 ? HERO_TEXT_SIZE_MOBILE : HERO_TEXT_SIZE) + 'px';
      }
      overlayLink.style.transform = 'none';
      overlayLink.style.opacity   = '1';
    }

    /* ── Scroll thresholds ── */
    const isMobileInit     = window.innerWidth < 769;
    const SCROLL_THRESHOLD = isMobileInit ? window.innerHeight * 0.02 : window.innerHeight * 0.05;
    const SCROLL_COMPLETE  = isMobileInit ? window.innerHeight * 0.15 : window.innerHeight * 0.25;

    /* ── Scroll handler — fade only, no movement ── */
    let ticking    = false;
    let isScrolled = false;

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(updateLogo);
        ticking = true;
      }
    }

    function updateLogo() {
      ticking = false;

      const scrollY  = window.pageYOffset || document.documentElement.scrollTop || 0;
      const raw      = (scrollY - SCROLL_THRESHOLD) / (SCROLL_COMPLETE - SCROLL_THRESHOLD);
      const progress = Math.max(0, Math.min(1, raw));

      if (progress === 0) {
        overlay.classList.remove('dmy-hero-logo--transitioning', 'dmy-hero-logo--hidden');
        if (isScrolled) {
          isScrolled = false;
          document.body.classList.remove('dmy-hero-scrolled');
        }
        applyHeroState();
        return;
      }

      overlay.classList.add('dmy-hero-logo--transitioning');

      if (progress >= 1) {
        overlay.classList.add('dmy-hero-logo--hidden');
        if (!isScrolled) {
          isScrolled = true;
          document.body.classList.add('dmy-hero-scrolled');
        }
        return;
      }

      /* Fading — no movement */
      overlay.classList.remove('dmy-hero-logo--hidden');
      if (isScrolled) {
        isScrolled = false;
        document.body.classList.remove('dmy-hero-scrolled');
      }
      overlayLink.style.transform = 'none';
      overlayLink.style.opacity   = String(1 - easeInOut(progress));
    }

    function easeInOut(t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    }

    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        applyHeroState();
        updateLogo();
      }, 150);
    });

    applyHeroState();
    updateLogo();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

})();

document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {

    // ── SCROLL TO REVIEWS ──
    const carousel = document.querySelector('.junip-review-carousel');
    if (carousel) carousel.id = 'junip-reviews';

    const summary = document.querySelector('.junip-product-summary-rendered');
    if (summary) {
      summary.addEventListener('click', function(e) {
        e.preventDefault();
        const target = document.querySelector('#junip-reviews');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    // ── ARROW SCROLL ──
    const prevBtn = document.querySelector('.junip-review-carousel-arrow[aria-label="Previous"]');
    const nextBtn = document.querySelector('.junip-review-carousel-arrow[aria-label="Next"]');
    const scrollContainer = document.querySelector('.junip-review-carousel-container');

    if (scrollContainer && prevBtn && nextBtn) {
      // Use the actual card width as scroll distance
      const getScrollAmount = () => {
        const card = scrollContainer.querySelector('.junip-review-carousel-item, .junip-review-carousel-item-clickable');
        return card ? card.offsetWidth : 260;
      };

      prevBtn.style.pointerEvents = 'all';
      prevBtn.style.cursor = 'pointer';
      prevBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        scrollContainer.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });

      nextBtn.style.pointerEvents = 'all';
      nextBtn.style.cursor = 'pointer';
      nextBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        scrollContainer.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });
    }

  }, 2000);
});